const usersQueryKeys = {
    all: ['users'] as const,
    list: (accountId: string) => [...usersQueryKeys.all, accountId, 'list'] as const,
    get: (accountId: string, id: string) => [...usersQueryKeys.all, accountId, 'get', id] as const,
};

export default usersQueryKeys;
